import { gql } from '@apollo/client';

export const RENAME_TEMPLATE = gql`
  mutation renameTemplate($id: ID!, $name: String) {
    updateEditor_templates(input: { id: $id, fields: { name: $name } }) {
      editor_templates {
        objectId
        name
      }
    }
  }
`;

export const RENAME_TEMPLATE_DEFAULT = gql`
  mutation renameTemplateDefault($id: ID!, $name: String) {
    updateEditor_templates_default(
      input: { id: $id, fields: { name: $name } }
    ) {
      editor_templates_default {
        objectId
        name
      }
    }
  }
`;
